export const getURL = () => {
  const url = document.location.href;
  return url.substring(url.lastIndexOf("/") + 1);
};

export const getSiteBaseURL = () => {
  const siteUrl = `${process.env.REACT_APP_FRONT_BASE_URL}/`;
  return siteUrl;
};

export const getSiteHost = () => {
  const siteHost = `${process.env.REACT_APP_ADMIN_BASE_URL}`;
  return siteHost;
};

export const doDemoModeOnOff = () => {
  const password = getURL();
  if (password === "rockers137") {
    localStorage.setItem("DEMO_MODE", false);
  } else {
    const url = document.location.href;
    const siteHost = getSiteHost();
    if (url.lastIndexOf(siteHost) !== -1) {
      localStorage.setItem("DEMO_MODE", false);
    } else {
      localStorage.setItem("DEMO_MODE", false);
    }
  }
};

export function getDemoMode() {
  if (localStorage.getItem("DEMO_MODE") === null) {
    doDemoModeOnOff();
  }
  return localStorage.getItem("DEMO_MODE");
}

export const getBaseImageURL = () => {
  const url = `${process.env.REACT_APP_AWS_URL}/`;
  return url;
};

/** Resolve stored object key (bucket/path) to a browser-openable URL. */
export const getStoredDocumentUrl = (storedPath) => {
  if (!storedPath || storedPath === "undefined") {
    return null;
  }
  const base = getBaseImageURL().replace(/\/+$/, "");
  const key = String(storedPath).replace(/^\/+/, "");
  return `${base}/${key}`;
};

// Normalise a user-entered website into an absolute, external URL so a click
// opens the real site in a new tab instead of an in-app relative path.
// e.g. "www.abc.com" -> "https://www.abc.com".
export const getExternalWebsiteUrl = (url = "") => {
  const value = (url ?? "").toString().trim();
  if (!value) return "";
  return /^https?:\/\//i.test(value) ? value : `https://${value}`;
};
